import { render, staticRenderFns } from "./AssetRoleForm.vue?vue&type=template&id=a4c18ae8&scoped=true&"
import script from "./AssetRoleForm.vue?vue&type=script&lang=js&"
export * from "./AssetRoleForm.vue?vue&type=script&lang=js&"
import style0 from "./AssetRoleForm.vue?vue&type=style&index=0&id=a4c18ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c18ae8",
  null
  
)

export default component.exports